@if (loading) {
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
}

<div class="rc-content">
  <div id="condition" class="sticky-sidebar">
    <div class="shadow p-0">
      <div class="bs-canvas bs-canvas-anim bs-canvas-left">
        <!-- position-sticky-->
        <!-- Off-canvas sidebar markup, left/right or both. -->
        <app-rc-search-filter
          [comparisonDef]="this.comparisonDef"
          (applyCompareEvent)="onApplyRegCompare($event)"
          (listComparisonDefEvent)="onListRegCompare()"
          (deleteComparisonDefEvent)="onDeleteRegCompare($event)"
          >
        </app-rc-search-filter>
      </div>
    </div>
  </div>

  <div id="result" class="main">
    <div class="main-header">
      <h5>{{ comparison }}</h5>
      <div class="button-row">
        <button
          mat-button
          (click)="onSaveComparison()"
          [disabled]="compareData.length === 0"
          >
          <mat-icon>save</mat-icon>
        </button>
        <button
          mat-button
          (click)="exportexcel()"
          [disabled]="compareData.length === 0"
          >
          <mat-icon>file_download</mat-icon>
        </button>
      </div>
    </div>
    @if (compareData == null || compareData.length == 0) {
      <div
        class="table-print"
        >
        <h3>RegCompare Instructions</h3>
        <ul>
          <li>
            <p>
              Select the jurisdictions and topics you want to compare with federal
              requirements. You can select up to 5 jurisdictions and 15 topics to
              compare. Click <b>Apply</b> to run the comparison. The comparison
              results are organized into rows by topic and into columns by
              jurisdiction. If you have chosen more than one topic, you can
              further refine the results by selecting one of the topics under the
              topic filter. This allows you to focus on a single topic in the
              results. If there are no state differences for a topic, we do not
              include that row in the results.
            </p>
          </li>
          <li>
            <p>
              To save your comparison for future use, click the disk icon in the
              top right corner of the screen. Enter a comparison name and click
              <b>Save</b>. You can access your saved comparisons by expanding the
              <b>Comparison Name</b> drop down in the filter panel and clicking
              <b>Run a Saved Comparison</b>.
            </p>
          </li>
          <li>
            <p>
              To export the results, select the download icon in the top right
              corner of the screen. This will download the results to an Excel
              file which allows you to share the results with others, print, or
              conduct further analysis.
            </p>
          </li>
        </ul>
      </div>
    }
    @if (compareData !== null && compareData.length > 0) {
      <div
        class="table-print"
        >
        <table class="mat-table regcompare" id="excel-table">
          <thead>
            <tr class="mat-header">
              <th class="t1">Topic</th>
              <th class="t2">Federal</th>
              @for (state of selectedStates; track state) {
                <th class="t2">{{ state }}</th>
              }
            </tr>
          </thead>
          <tbody class="displayContents">
            @for (rbdata of displayData; track rbdata) {
              @for (para of rbdata.rbState; track para) {
                <tr class="mat-row">
                  <td data-t="s" class="t1">
                    {{ rbdata.rb }} - {{ para.paraNum }}
                  </td>
                  <td data-t="s" class="t2" [innerHtml]="para.question"></td>
                  @for (st of para.paraSd; track st) {
                    <td data-t="s" class="t2" [innerHtml]="st.stateDiff"></td>
                  }
                </tr>
              }
              @if (rbdata.rbState.length === 0) {
                <tr class="mat-row">
                  <td class="t1">{{ rbdata.rb }}</td>
                  <td class="t2">All same</td>
                  @for (st of selectedStates; track st) {
                    <td class="t2">All same</td>
                  }
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>
